import { type RefObject, useEffect } from 'react'
import { useLocation } from 'react-router'

interface Umami {
  url?: string
  title?: string
  screen?: string
  website: string
  hostname?: string
  language?: string
  referrer?: string
}

type UmamiCallback = (arg0: Umami) => void

declare global {
  interface Window {
    umami: {
      track: (arg0: Umami | UmamiCallback) => void
    }
  }
}

function pageView(pathname: string): void {
  if (!ENV.UMAMI_ID) return

  const { height, width } = window.screen
  const { title, referrer } = document
  try {
    window.umami.track({
      website: ENV.UMAMI_ID,
      hostname: window.location.hostname,
      url: pathname,
      title,
      language: navigator.language,
      referrer,
      screen: `${width}x${height}`,
    })
  } catch (err) {
    console.error(err)
  }
}

export function useUmami(umamiRef: RefObject<HTMLScriptElement | null>) {
  const { pathname } = useLocation()

  useEffect(() => {
    const umami = umamiRef.current
    if (ENV.UMAMI_ID && ENV.UMAMI_ENABLED && umami) {
      try {
        if (window.umami) pageView(pathname)
        else umami.addEventListener('load', () => pageView(pathname))
      } catch (err) {
        console.error(err)
      }
    }
  }, [umamiRef, pathname])
}
